import { buildStoreListRequest } from '@eliadmin/core/src/api/store-list-request';
import { buildAuthHeader, fetchData } from '@eliadmin/core/src/api/fetcher';
import type { GenericRequest, PaginationMeta } from '@eliadmin/core/src/api/api-types';
import type { FetchBlogsQuery } from '@eliadmin/core/src/api/blogs/blogs-api';
import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import type { FetchTravelAgencyToursResponse } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';
import { storeApiResources, type ApiSort } from '@eliadmin/eli-api-contract/store';
import type { TourFilter } from '../stores/tours-store';
import { buildToursListOptions } from './tour-list-options';

/** Keep the core transport's locale, authentication, response and caching behavior. */
export function fetchProjectBlogs(
  req: GenericRequest<{
    query?: Omit<FetchBlogsQuery, 'filter' | 'orderBy' | 'order'> & {
      sort?: ApiSort<typeof storeApiResources.storeBlogs>;
    };
    authToken?: string;
  }>,
) {
  const { where, sort, ...query } = req.query ?? {};
  return fetchData<{ data: Blog[]; meta: PaginationMeta }>({
    ...buildStoreListRequest(storeApiResources.storeBlogs, { query, where, sort }),
    locale: req.locale,
    headers: buildAuthHeader(req.authToken),
  });
}

/** Price bounds must use top-level contract filters, not a price where expression. */
export function fetchProjectTours(
  req: GenericRequest<{
    filter: TourFilter;
    page: number;
    signal?: AbortSignal;
  }>,
) {
  return fetchData<FetchTravelAgencyToursResponse>({
    ...buildStoreListRequest(storeApiResources.storefrontTravelAgencyTours, {
      ...buildToursListOptions(req.filter),
      query: { page: req.page, results: 20 },
    }),
    locale: req.locale,
    signal: req.signal,
  });
}
